import React from 'react';
// components
import Icon from '../Icon/Icon';
// styles
import styles from './ModuleInclude.mod.css';

const ModuleInclude = ({ module }) => {
  const include = {
    inputs: module.input_count,
    lectures: module.lecture_count,
    quizzes: module.quiz_count,
    videos: module.video_count,
    slideshow: module.slideshow_count
  };
  const iconTypes = {
    inputs: 'pen',
    lectures: 'file',
    quizzes: 'quiz',
    videos: 'video',
    slideshow: 'slideshow'
  };

  return (
    <div className={styles.includeList}>
      {Object.keys(include).map(
        (key, index) =>
          include[key] > 0 ? (
            <div className={styles.includeItem} key={index}>
              <div className={styles.iconWrap}>
                <Icon type={iconTypes[key]} className={styles.icon} />
                <div className={styles.iconBg} />
              </div>
              <span>
                <strong>{include[key]}</strong> {key}
              </span>
            </div>
          ) : null
      )}
    </div>
  );
};

export default ModuleInclude;



// WEBPACK FOOTER //
// ./src/components/ModuleInclude/ModuleInclude.jsx